import React from "react";
import Model from "../../common/Model";

const FeedbackForm = ({
  onClose,
  loading,
  handleSubmit,
  feedback,
  setFeedback,
}) => {
  return (
    <div>
      <Model
        closeModal={onClose}
        title={`Add Feedback`}
        isForm={true}
        loading={loading}
        handleSubmit={handleSubmit}
      >
        <div>
          <label className="capitalize text-base font-medium text-gray-700">
            Your Feedback
          </label>
          <textarea
            className="w-full p-4 border rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
            rows="5"
            placeholder="Write your feedback here..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
        </div>
      </Model>
    </div>
  );
};

export default FeedbackForm;
